<div fxLayout="column">
  @for (journal of detail; track journal) {
    <div fxLayout="column" class="journal">
      <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start" class="header">
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="start start">
          <span fxFlex="50">JE Number</span>
          <span fxFlex="50">Controlling Fund</span>
        </div>
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="end start" class="numeric">
          <span fxFlex="33">Post Date</span>
          <span fxFlex="33">Accrual Reversing Date</span>
          <span fxFlex="33">Added Date</span>
        </div>
      </div>
      <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start" class="row">
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="start start">
          <span fxFlex="50">{{journal.Number}}</span>
          <span fxFlex="50">{{journal.ControllingFund}}</span>
        </div>
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="end start" class="numeric">
          <span fxFlex="33">{{journal.PostDate | date:'M/d/yyyy'}}</span>
          <span fxFlex="33">{{journal.AccuralDate | date:'M/d/yyyy'}}</span>
          <span fxFlex="33">{{journal.AddedDate | date:'M/d/yyyy'}}</span>
        </div>
      </div>
      <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start" class="header row">
        <span fxFlex="33">Account Number</span>
        <span fxFlex="33">Account Name</span>
        <span fxFlex="33">Project Account</span>
        <span fxFlex="33">Description</span>
        <span fxFlex="33">IFT</span>
        <span fxFlex="33" class="numeric">Amount</span>
      </div>
      @for (entry of journal.Distributions; track entry) {
        <div fxLayout="column">
          <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start" class="row">
            <span fxFlex="33">{{entry.AccountNumber}}</span>
            <span fxFlex="33">{{entry.AccountName}}</span>
            <span fxFlex="33">{{entry.ProjectAccount}}</span>
            <span fxFlex="33">{{entry.Description}}</span>
            <span fxFlex="33">{{entry.InterFundTransfer}}</span>
            <span fxFlex="33" class="numeric">{{entry.Amount | currency}}</span>
          </div>
        </div>
      }
      <mat-divider></mat-divider>
    </div>
  }

  <div fxFlex="auto" fxLayout="column">
    <h3>Account Summary</h3>
    <div fxLayout="column" class="center">
      <div fxFlex="50" fxLayout="row">
        <span fxFlex="40"><strong>Account</strong></span>
        <span fxFlex="20" class="numeric"><strong>Total Debits</strong></span>
        <span fxFlex="20" class="numeric"><strong>Total Credits</strong></span>
        <span fxFlex="20" class="numeric"><strong>Amount</strong></span>
      </div>
      @for (summary of summaries; track summary) {
        <div fxLayout="row" fxLayoutAlign="space-between start" class="row">
          <span fxFlex="40">{{summary.key}}</span>
          <span fxFlex="20" class="numeric">{{summary.debit | currency}}</span>
          <span fxFlex="20" class="numeric">{{summary.credit | currency}}</span>
          <span fxFlex="20" class="numeric">{{summary.amount | currency}}</span>
        </div>
      }
    </div>
  </div>
</div>